import component from './list';
import './../api';

export default (MODULE) => {

  const resolver = function (response) {
    if (response.data) {
      const data = response.data;
      if (data.error) return this.reject(data.error);
      return this.resolve(data);
    } else {
      throw new Error('Invalid server response');
    }
  };

  /* @ngInject */
  const resolve = {
    // pulled from legacy
    'allowed': AppCtrl.authResolver
  };

  const DayviewComponent = component(MODULE);

  angular.module(MODULE)
    /* @ngInject */
    .config(($stateProvider) => {
      $stateProvider
        .state('day.bookings', {
          url: '/bookings/:day',
          auth: true,
          views: {
            'day': DayviewComponent
          },
          resolve: Object.assign(resolve, {
            'day': (allowed, $transition$) => {
              const toParams = $transition$.params("to");
              if (toParams.day === 'tomorrow') return moment().hours(0).minutes(0).seconds(0).add(1, 'day');
              if (toParams.day === 'today') return moment().hours(0).minutes(0).seconds(0);
              if (toParams.day === 'yesterday') return moment().hours(0).minutes(0).seconds(0).subtract(1, 'day');
              const date = moment.utc(toParams.day, 'MM-DD-YY');
              return date;
            },
            'bookings': (day, BookingAPI, $q, $rootScope) => {
              const deferred = $q.defer();
              const API = BookingAPI.req();
              const Bookings = API.list({ date: day.format('MM-DD-YY') }).$promise;
              Bookings.then((bookings) => {
                deferred.resolve(bookings.results);
                $rootScope.dayWorking = false;
              });
              return deferred.promise;
            }
          })
        });
    });

};


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/reservations/dayview/route.js